import { useEffect, useState } from 'react';
import { apiUrl } from '../config/api';

/**
 * Fetches published documents for a category from the PHP API.
 * status is one of: 'loading' | 'success' | 'error'.
 */
export function useDocuments(category) {
  const [documents, setDocuments] = useState([]);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    setStatus('loading');

    fetch(apiUrl(`/documents.php?category=${encodeURIComponent(category)}`))
      .then((res) => {
        if (!res.ok) throw new Error('Request failed');
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;
        if (!data || data.success !== true) throw new Error('Request failed');
        setDocuments(Array.isArray(data.documents) ? data.documents : []);
        setStatus('success');
      })
      .catch(() => {
        if (cancelled) return;
        setStatus('error');
      });

    return () => {
      cancelled = true;
    };
  }, [category]);

  return { documents, status };
}
